import React, { FC } from 'react'
import { Formik, Form } from 'formik'
import { billingInfoValidationSchema } from '../schema'
import { Tooltip } from '@pepper/ui'

/* @pepper/utils */

import BillingForm from './BillingForm'

import QueryIcon from 'assets/images/billingQuery.svg'

import styles from '../_.module.css'

interface Props {
  billingInformation: SmeBillingInformation
  onSubmit: (values: SmeBillingInformation) => void
  totalPrice: PayScale
  loading: boolean
  paymentFormRef?: React.RefObject<any>
}
const BillingInfo: FC<Props> = ({
  billingInformation,
  onSubmit,
  totalPrice,
  loading,
  paymentFormRef,
}) => {
  return (
    <div className={styles.formContainer}>
      <div className={styles.billingFormHeader}>
        <div className={styles.briefHeaderTitle}>
          <div className={styles.billText}>Billing Information</div>
          <div>
            <Tooltip
              placement="right"
              title={
                <span className={styles.tooltipTitle}>
                  Your official billing information for this project will need
                  to be filled in
                </span>
              }
            >
              <img src={QueryIcon} alt="query" className={styles.queryIcon} />
            </Tooltip>
          </div>
        </div>
      </div>
      <Formik
        initialValues={billingInformation || {}}
        validationSchema={billingInfoValidationSchema}
        onSubmit={onSubmit}
        enableReinitialize={true}
        innerRef={paymentFormRef}
      >
        {(props): React.ReactNode => {
          return (
            <Form className={styles.form}>
              <BillingForm formikProps={props} totalPrice={totalPrice} />
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default BillingInfo
